"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemPropTypes = exports["default"] = exports.basePropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _map = _interopRequireDefault(require("lodash/map"));
var _react = _interopRequireWildcard(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _styledComponents = require("styled-components");
var DropdownS = _interopRequireWildcard(require("./DropdownStyles"));
var _Icon = _interopRequireDefault(require("../Icons/Icon"));
var _Input = _interopRequireDefault(require("../Inputs/Input"));
var _Loader = _interopRequireDefault(require("../Loaders/Loader"));
var _LoaderContainer = _interopRequireDefault(require("../Loaders/LoaderContainer"));
var _PopoverBase = _interopRequireDefault(require("../Tooltips/PopoverBase"));
var _Text = _interopRequireDefault(require("../Typography/Text"));
var _useHighlightInteraction = _interopRequireDefault(require("./useHighlightInteraction"));
var _base = require("../Icons/components/base");
var _helpers = require("../helpers");
var _excluded = ["items", "loading", "searchTerm", "setSearchTerm", "placeholder", "onBlur", "hasError", "userMustType", "listVariant", "withClearButton", "selection", "setSelection", "onSelectItem", "listWidth", "renderItemContent", "listW", "automationHook", "disabled"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var itemPropTypes = _propTypes["default"].shape({
  /**  The value of the item */
  value: _propTypes["default"].string,
  /**  Label of the item - will be visible as item text */
  label: _propTypes["default"].string,
  /** Optional: the section under which item should be nested */
  section: _propTypes["default"].string,
  /** When true item cannot be selected */
  disabled: _propTypes["default"].bool,
  /** Another label for the item, used as the input text when this item is selected. This is used in cases when we need to have different labels in the input and in the list option. */
  displayLabel: _propTypes["default"].string
});
exports.itemPropTypes = itemPropTypes;
var basePropTypes = {
  /** An array of items */
  items: _propTypes["default"].arrayOf(itemPropTypes).isRequired,
  /** Wether or not the items are being loaded */
  loading: _propTypes["default"].bool.isRequired,
  /** The text displayed in the input field. State is defined in parent because it may need to be debounced - as it is for search dropdown */
  searchTerm: _propTypes["default"].string.isRequired,
  /** Function to set that text  */
  setSearchTerm: _propTypes["default"].func.isRequired,
  /** Function that will be executed on blur. */
  onBlur: _propTypes["default"].func,
  /** Placeholder for search input */
  placeholder: _propTypes["default"].string,
  /** Boolean for adding error styles */
  hasError: _propTypes["default"].bool,
  /** Show the user a text letting them know that they need to start typing */
  userMustType: _propTypes["default"].bool,
  /** A variant passed to the list, to add/ remove styles like separators. By default it has separators */
  listVariant: _propTypes["default"].oneOf(["separators", "noSeparators"]),
  /** When true, add a clear button to the input, that clears the selection. Defaults to true. */
  withClearButton: _propTypes["default"].bool,
  /** Allows overwriting the rendering of the dropdown item text with any component that takes the item as prop */
  renderItemContent: _propTypes["default"].func,
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string
};
exports.basePropTypes = basePropTypes;
var propTypes = _objectSpread(_objectSpread({}, basePropTypes), {}, {
  /** The selection for the dropdown - works for either a single or a multi value */
  selection: _propTypes["default"].oneOfType([itemPropTypes, _propTypes["default"].arrayOf(itemPropTypes)]),
  /** Function that updates the selection */
  setSelection: _propTypes["default"].func.isRequired,
  /** Function for when an option is selected - should set the value of the Dropdown */
  onSelectItem: _propTypes["default"].func.isRequired,
  /** DEPRECATED: Specifies the popover's width. Use "listW" */
  listWidth: _propTypes["default"].string,
  /** Specifies the popover's width */
  listW: _propTypes["default"].string
});
var DynamicDropdownBase = function DynamicDropdownBase(_ref) {
  var items = _ref.items,
    loading = _ref.loading,
    searchTerm = _ref.searchTerm,
    setSearchTerm = _ref.setSearchTerm,
    placeholder = _ref.placeholder,
    _onBlur = _ref.onBlur,
    hasError = _ref.hasError,
    userMustType = _ref.userMustType,
    listVariant = _ref.listVariant,
    _ref$withClearButton = _ref.withClearButton,
    withClearButton = _ref$withClearButton === void 0 ? false : _ref$withClearButton,
    selection = _ref.selection,
    setSelection = _ref.setSelection,
    onSelectItem = _ref.onSelectItem,
    listWidth = _ref.listWidth,
    renderItemContent = _ref.renderItemContent,
    listW = _ref.listW,
    automationHook = _ref.automationHook,
    disabled = _ref.disabled,
    rest = _objectWithoutProperties(_ref, _excluded);
  (0, _helpers.useDeprecate)({
    listWidth: listWidth
  }, "DynamicDropDownBase");

  // state for list
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHoveringList = _useState2[0],
    setIsHoveringList = _useState2[1];
  // states for options and search
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    highlightIndex = _useState4[0],
    setHighlightIndex = _useState4[1];
  var inputWrapperRef = (0, _react.useRef)(null);
  var isMulti = (0, _isArray["default"])(selection);
  var theme = (0, _styledComponents.useTheme)();
  var _useHighlightInteract = (0, _useHighlightInteraction["default"])(highlightIndex),
    highlightedItemRef = _useHighlightInteract.highlightedItemRef,
    listContainerRef = _useHighlightInteract.listContainerRef,
    scrollToHighlight = _useHighlightInteract.scrollToHighlight,
    preventScrollToHighlight = _useHighlightInteract.preventScrollToHighlight,
    disableMouseHighlighting = _useHighlightInteract.disableMouseHighlighting,
    withoutMouseHighlight = _useHighlightInteract.withoutMouseHighlight;
  renderItemContent = renderItemContent || function (item) {
    return /*#__PURE__*/_react["default"].createElement(_Text["default"], null, item.label);
  };
  var moveHighlight = function moveHighlight() {
    var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    setHighlightIndex(direction > 0 ? Math.min(highlightIndex + direction, items.length - 1) : Math.max(highlightIndex + direction, 0));
    scrollToHighlight();
    disableMouseHighlighting();
  };
  var selectItem = function selectItem(item, closePopover) {
    // update the value of the dropdown
    // this will in turn set the selectedItem and the searchTerm
    onSelectItem(item);
    // close the list
    closePopover();
    setIsHoveringList(false);
  };
  var isMatch = function isMatch(item) {
    // for arrays we search in selection
    if (isMulti) {
      return selection === null || selection === void 0 ? void 0 : selection.find(function (selectedItem) {
        return selectedItem.value === item.value;
      });
    }
    // for single
    return item.value === (selection === null || selection === void 0 ? void 0 : selection.value);
  };
  return /*#__PURE__*/_react["default"].createElement(_PopoverBase["default"], {
    onOpen: function onOpen() {
      var firstSelectedItem = isMulti ? selection[0] : selection;
      setHighlightIndex(firstSelectedItem !== null && firstSelectedItem !== void 0 && firstSelectedItem.value ?
      // The highlighted index should be the selected item.
      // TODO: it doesn't scroll to initially selected item
      items.findIndex(function (item) {
        return item.value === firstSelectedItem.value;
      }) : 0);
      scrollToHighlight();
    },
    onClose: function onClose() {
      var newSearchTerm = isMulti ? "" : (selection === null || selection === void 0 ? void 0 : selection.label) || "";
      setSearchTerm === null || setSearchTerm === void 0 ? void 0 : setSearchTerm(newSearchTerm);
    },
    renderTrigger: function renderTrigger(_ref2) {
      var openPopover = _ref2.openPopover,
        closePopover = _ref2.closePopover,
        isOpen = _ref2.isOpen;
      return (
        /*#__PURE__*/
        /*
         * We will us an extra wrapper around input to get the width in pixels of the
         * input, in order to pass it to the dropdown list. Do not pass a ref directly
         * to the input to preserve the option of passing in a ref from the outside
         * parent
         */
        _react["default"].createElement(DropdownS.InputWrapper, {
          ref: inputWrapperRef
        }, /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({}, rest, {
          withClearButton: withClearButton,
          renderRight: function renderRight() {
            return /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
              name: theme.icons.select,
              color: "inputButton",
              pR: "xs"
            });
          },
          showDropdown: isOpen,
          value: searchTerm,
          hasError: hasError,
          placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "Type to search...",
          onFocus: openPopover,
          disabled: disabled,
          onBlur: function onBlur(e) {
            if (!isHoveringList) {
              // Click outside the list
              _onBlur === null || _onBlur === void 0 ? void 0 : _onBlur(e);
              closePopover();
            }
            // Else we are clicking inside the list so we are selecting an item
            // and that case is dealt with inside the onClick function of the
            // item.
          },

          onChange: function onChange(e) {
            // content of search input changes
            if (!isOpen) {
              openPopover();
            }
            setSearchTerm === null || setSearchTerm === void 0 ? void 0 : setSearchTerm(e.target.value);
            // Select first item of the new filtered options
            setHighlightIndex(0);
          },
          onKeyDown: function onKeyDown(e) {
            switch (e.keyCode) {
              // Enter
              case 13:
                if (isOpen) {
                  selectItem(items[highlightIndex], closePopover);
                } else {
                  openPopover();
                }
                break;
              // Arrow Up
              case 38:
                e.preventDefault();
                openPopover();
                moveHighlight(-1);
                break;
              // Arrow Down
              case 40:
                e.preventDefault();
                openPopover();
                moveHighlight(1);
                break;
              // Escape
              case 27:
                e.preventDefault();
                // prevent closing the modal with esc
                e.stopPropagation();
                // close the list
                closePopover();
                break;
              default:
                break;
            }
          },
          onClear: function onClear(e) {
            selectItem({}, closePopover);
            setSearchTerm === null || setSearchTerm === void 0 ? void 0 : setSearchTerm("");
            setHighlightIndex(0);
          },
          automationHook: automationHook
        })))
      );
    }
  }, function (_ref3) {
    var _inputWrapperRef$curr;
    var isOpen = _ref3.isOpen,
      togglePopover = _ref3.togglePopover,
      closePopover = _ref3.closePopover,
      popoverState = _ref3.popoverState;
    return /*#__PURE__*/_react["default"].createElement(DropdownS.ListContainer, {
      ref: listContainerRef,
      onMouseEnter: function onMouseEnter() {
        return setIsHoveringList(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setIsHoveringList(false);
      },
      w: (listW !== null && listW !== void 0 ? listW : listWidth) || "".concat((_inputWrapperRef$curr = inputWrapperRef.current.getBoundingClientRect().width) !== null && _inputWrapperRef$curr !== void 0 ? _inputWrapperRef$curr : 300, "px")
    }, /*#__PURE__*/_react["default"].createElement(DropdownS.List, {
      variant: listVariant
    }, loading ? /*#__PURE__*/_react["default"].createElement(_LoaderContainer["default"], null, /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
      size: "20px"
    })) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, items.length ? (0, _map["default"])(items, function (item, idx) {
      var _item$value;
      var isSelected = isMatch(item);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: idx
      }, item.section && (!idx || item.section !== items[idx - 1].section) && /*#__PURE__*/_react["default"].createElement(DropdownS.SectionTitle, {
        variant: listVariant
      }, /*#__PURE__*/_react["default"].createElement("span", null, item.section)), /*#__PURE__*/_react["default"].createElement(DropdownS.Item, _extends({
        highlight: idx === highlightIndex,
        isSelected: isSelected,
        isDisabled: item.disabled,
        ref: idx === highlightIndex ? highlightedItemRef : null,
        onClick: function onClick() {
          if (item.disabled) {
            return;
          }
          selectItem(item, closePopover);
        },
        onMouseEnter: function onMouseEnter() {
          if (withoutMouseHighlight) {
            return;
          }
          setHighlightIndex(idx);
          preventScrollToHighlight();
        }
      }, (0, _automationHooks.hook)(automationHook, "value-".concat(item === null || item === void 0 ? void 0 : (_item$value = item.value) === null || _item$value === void 0 ? void 0 : _item$value.toLowerCase()))), isSelected && /*#__PURE__*/_react["default"].createElement(DropdownS.SelectedIconWrapper, null, /*#__PURE__*/_react["default"].createElement(_base.Check, {
        color: "focus"
      })), renderItemContent(item)));
    }) : /*#__PURE__*/_react["default"].createElement(_Text["default"], {
      textAlign: "center",
      mV: "base"
    }, userMustType ? "Type something..." : "No results"))));
  });
};
DynamicDropdownBase.propTypes = propTypes;
var _default = DynamicDropdownBase;
exports["default"] = _default;